import Head from "next/head";

const FaqSchema = ({ faqData }) => {
    
  return (
    <Head>
      <script
        id="FAQPageSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.a,
              },
            })),
          }),
        }}
      />
    </Head>
  );
};

export default FaqSchema;
